import Marquee from "react-fast-marquee";
import { useLanguage } from "@/lib/i18n";

export default function EditorialMarquee() {
  const { t } = useLanguage();
  const items = t("marquee.items");
  return (
    <div className="border-y border-white/10 py-8 md:py-10 overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-syne font-bold text-5xl md:text-7xl tracking-tighter mx-8 ${
                i % 2 === 0 ? "text-outline" : "text-outline-orange"
              }`}
            >
              {item}
            </span>
            <span className="w-3 h-3 bg-[#FF5A00] rotate-45 mx-4" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
